var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoFinish = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#999}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.546,22.423l.258-.072a.465.465,0,0,0,.324-.574L1.179,11.245a.583.583,0,0,0-.718-.4l-.033.009a.582.582,0,0,0-.4.717L2.971,22.1A.467.467,0,0,0,3.546,22.423Z",
    transform: "translate(0 -8.44)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.838,7.572a11.175,11.175,0,0,1-2.57-1.765.229.229,0,0,1-.065-.234,32.932,32.932,0,0,0,.848-4.383c.029-.246-.1-.318-.244-.149C14.058,4.322,9.3.441,6.47,3.423a.961.961,0,0,1,.08.2L8.463,10.46c2.836-2.946,7.576.911,10.32-2.363C18.923,7.929,18.949,7.62,18.838,7.572Z",
    transform: "translate(-4.907 -.95)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoFinish);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_finish.16cf8d89454d808855805cd4123f1df0.svg";